import React from "react";
import {ActionRow, ActionRowButton, ActionRowMoreButton, Icon} from "peggirkit";
import {PlusIcon, TrashIcon} from "@heroicons/react/24/outline";
import {FormattedMessage} from "react-intl";
import router from "@/routing/Router";
import {SetStateFn} from "@/utils/SetStateUtils";
import {useFormContext} from "react-hook-form";
import {LoyaltyRewardDetails} from "@/data/entities/loyaltyReward";


type Props = {
    setShowDeleteModal: SetStateFn<boolean>,
    setLoyaltyReward: SetStateFn<LoyaltyRewardDetails | null>,
};

const LoyaltyRewardHeadingActions = ({setShowDeleteModal, setLoyaltyReward}: Props) => {
    const {reset} = useFormContext();

    return (
        <ActionRow
            useMoreButton={true}
            moreButton={
                <ActionRowMoreButton>
                    <FormattedMessage id={"more"}/>
                </ActionRowMoreButton>
            }
            moreButtonPositioning={"end"}
            breakpoints={{
                md: {
                    moreButtonPositioning: "start",
                },
            }}
        >
            <ActionRowButton
                color={"danger"}
                iconBefore={<Icon icon={TrashIcon}/>}
                buttonAction={{
                    as: "button",
                    actionProps: {
                        onClick: e => {
                            e.preventDefault();
                            setShowDeleteModal(true);
                        },
                    },
                }}
                showInRowBreakpoint={"xl"}
            >
                <FormattedMessage id={"delete"}/>
            </ActionRowButton>

            <ActionRowButton
                color={"secondary"}
                iconBefore={<Icon icon={PlusIcon}/>}
                buttonAction={{
                    as: "reactRouterLink",
                    actionProps: {
                        to: router.newLoyaltyReward.absolutePath(),
                        onClick: () => {
                            reset();
                            setLoyaltyReward(null);
                        }
                    }
                }}
            >
                <FormattedMessage id={"newLoyaltyReward"}/>
            </ActionRowButton>
        </ActionRow>
    );
};

export default LoyaltyRewardHeadingActions;